export abstract class Mapper<InType = any, OutType = any> {
	public abstract map(data: InType): OutType | undefined;

	protected throwInvalid = (msg?: string) => {
		throw new Error(msg || 'Invalid data!');
	};
}
